import React, { useEffect, useRef, useState } from 'react';

import { default as styles } from '../../scss/components/AffirmMessage.module.scss';
import { withCssModulesClassNames } from '../../common/nextMigrationHelpers';
import { refreshAffirm } from '../global/ProductHelpers';

const withCssModulesClassNamesHandler = withCssModulesClassNames(styles);

type AffirmMessageProps = {
  amount: string | number;
};

const showHideObserver = (onMutation: () => void): MutationCallback => (_records, observer) => {
  onMutation();
  observer.disconnect();
};

const observerOptions = {
  childList: true,
};

const AffirmMessage = ({ amount }: AffirmMessageProps) => {
  const [isMounted, setIsMounted] = useState(false);
  const [isHidden, setIsHidden] = useState(true);
  const affirmEl = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Avoids rendering on server-side
    setIsMounted(true);
  }, []);

  useEffect(() => {
    const observer = new MutationObserver(
      showHideObserver(() => setIsHidden(false)),
    );

    if (isMounted && affirmEl.current) {
      observer.observe(affirmEl.current, observerOptions);

      refreshAffirm();
    }

    return () => {
      observer.disconnect();
    };
  }, [isMounted]);

  return isMounted ? (
    <div
      className={withCssModulesClassNamesHandler(
        'affirm-line',
        { 'affirm-line--hidden': isHidden },
      )}
      data-testid="affirm-PDP-wrapper"
    >
      <i className={withCssModulesClassNamesHandler('icon icon-affirm-logo')} />
      <p
        ref={affirmEl}
        className={withCssModulesClassNamesHandler('affirm-as-low-as')}
        data-page-type="product"
        data-affirm-type="text"
        data-amount={amount}
        data-testid="affirm-PDP-text"
      />
    </div>
  ) : null;
};

export default AffirmMessage;
